import { IS_MAC_PLATFORM } from 'core-components/helpers/eventKeys'

import { TOOLBAR_BUTTONS } from '../../interface/IToolbar'

const getHotKeyModKeyString = (key: string) =>
  IS_MAC_PLATFORM ? `(\u2318+${key})` : `(ctrl+${key})`
const getHotKeyModAndShiftString = (key: string) =>
  IS_MAC_PLATFORM ? `(\u2318+\u21E7+${key})` : `(ctrl+\u21E7+${key})`

export const TOOLBAR_TITLES = {
  [TOOLBAR_BUTTONS.UploadFile]: 'Add File',
  [TOOLBAR_BUTTONS.UploadImage]: 'Add Image',
  [TOOLBAR_BUTTONS.Link]: 'Add Link',
  [TOOLBAR_BUTTONS.Undo]: `Undo ${getHotKeyModKeyString('Z')}`,
  [TOOLBAR_BUTTONS.Redo]: `Redo ${getHotKeyModAndShiftString('Z')}`,
  [TOOLBAR_BUTTONS.Size]: 'Size',
  [TOOLBAR_BUTTONS.FontSize]: 'Font size',
  [TOOLBAR_BUTTONS.Bold]: `Bold ${getHotKeyModKeyString('B')}`,
  [TOOLBAR_BUTTONS.Italic]: `Italic ${getHotKeyModKeyString('I')}`,
  [TOOLBAR_BUTTONS.Underline]: `Underline ${getHotKeyModKeyString('U')}`,
  [TOOLBAR_BUTTONS.Strikethrough]: `Strikethrough ${getHotKeyModAndShiftString('X')}`,
  [TOOLBAR_BUTTONS.BulletedList]: 'Bulleted list',
  [TOOLBAR_BUTTONS.NumberedList]: 'Numbered list',
  [TOOLBAR_BUTTONS.BlockQuote]: 'Block Quote',
  [TOOLBAR_BUTTONS.CodeBlock]: `Code Block`,
  [TOOLBAR_BUTTONS.LinkButton]: 'Add Link Button',
  [TOOLBAR_BUTTONS.Separator]: 'Separator',
  [TOOLBAR_BUTTONS.HorizontalRule]: 'Horizontal line',
  [TOOLBAR_BUTTONS.IFrame]: 'Add IFrame',
  [TOOLBAR_BUTTONS.Action]: 'Action block',
  [TOOLBAR_BUTTONS.ColumnOptions]: 'Layout options',
  [TOOLBAR_BUTTONS.Video]: 'Add Video',
  [TOOLBAR_BUTTONS.Table]: 'Add Table',
  [TOOLBAR_BUTTONS.ExpandBlock]: 'Add Expand Block',
  [TOOLBAR_BUTTONS.Increase]: 'Increase',
  [TOOLBAR_BUTTONS.Decrease]: 'Decrease',
  [TOOLBAR_BUTTONS.Subscript]: 'Subscript',
  [TOOLBAR_BUTTONS.Superscript]: 'Superscript',
  [TOOLBAR_BUTTONS.Align]: 'Align Options',
  [TOOLBAR_BUTTONS.Color]: 'Font Color Options',
  [TOOLBAR_BUTTONS.BackgroundColor]: 'Background Color Options',
}
